import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { useInfiniteTaskListQuery } from '@/hook';
import { Close, VDialog, VFlex, VStack, cn } from '@/package';
import type { ModelTrainingForm, Modeling } from '@/type';

import SplitCardContainer from './SplitCardContainer';

const DataSplitModal = ({
  modelingDetail,
  visible,
  onUpdateVisible,
}: {
  modelingDetail: Modeling;
  visible: boolean;
  onUpdateVisible(visible: boolean): void;
}) => {
  const { data, isLoading } = useInfiniteTaskListQuery({
    hasObject: true,
    taskID: modelingDetail.taskInfo.map(t => +t.taskID),
  });
  const { watch, setValue } = useForm<ModelTrainingForm>({
    defaultValues: {
      selectedTaskList: [],
      taskSplitRatios: {},
      modelName: '',
      modelDescription: '',
      modelNameValidationErrorMessage: '',
      epoch: 24,
    },
  });

  useEffect(() => {
    if (isLoading || !data?.pages.length) return;

    setValue(
      'selectedTaskList',
      data.pages.map(p => p.data.resultData).flat(1),
    );
  }, [isLoading, data?.pages]);

  return (
    <VDialog dialogMainClass={cn('w-[712px] bg-white p-6')} visible={visible}>
      <VStack className="w-full" gap={1}>
        <VFlex justify="between" items="center">
          <div className="text-headline-sm text-blue-300">
            <strong>Data setting</strong>
          </div>
          <Close
            role="button"
            className="size-6 text-gray-400"
            onClick={() => onUpdateVisible(false)}
          />
        </VFlex>
        <SplitCardContainer
          deletable={false}
          disabled={true}
          watch={watch}
          setValue={setValue}
          updateTaskSplitRatio={() => {}}
          getTaskSplitRatio={taskID => {
            const finded = modelingDetail.taskInfo.find(
              t => t.taskID == taskID,
            );

            return {
              training: finded?.trainingRatio ?? 0,
              validation: finded?.validationRatio ?? 0,
            };
          }}
        />
      </VStack>
    </VDialog>
  );
};

DataSplitModal.displayName = 'DataSplitModal';

export default DataSplitModal;
